import { useEffect, useRef } from "react";
import { useAuthentication } from "hooks";
import useMessage from "hooks/useMessage";

const EVENTOS = ["mousemove", "mousedown", "keydown", "scroll", "touchstart", "click"];

/**
 * Cierra la sesión del usuario tras N minutos de inactividad, según la configuración
 * de la compañía (UsaCierreSesionInactividad + TiempoEsperaInactividadMinutos).
 * No hace nada si no hay sesión, la opción está desactivada o los minutos son <= 0.
 */
export default function useInactividadLogout() {
  const { usuario, logout } = useAuthentication();
  const { Warning } = useMessage();
  const timerRef = useRef();

  const habilitado = !!usuario?.Compania?.UsaCierreSesionInactividad;
  const minutos = Number(usuario?.Compania?.TiempoEsperaInactividadMinutos) || 0;

  useEffect(() => {
    if (!habilitado || minutos <= 0) return;
    const ms = minutos * 60 * 1000;

    const cerrar = () => {
      Warning({ message: "Su sesión se cerró por inactividad." });
      logout();
    };

    const reset = () => {
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(cerrar, ms);
    };

    EVENTOS.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    reset();

    return () => {
      clearTimeout(timerRef.current);
      EVENTOS.forEach((e) => window.removeEventListener(e, reset));
    };
  }, [habilitado, minutos, logout]);
}
